import React from 'react';
import { IconProps } from '.';

const SvgClassification = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M9.5 3.5v4h5v-4h-5ZM9 2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9ZM5.5 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM18.5 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='M4.75 11.25h14.5V16h-1.5v-3.25H6.25V16h-1.5v-4.75Z' clipRule='evenodd' />
      <path fill={color} d='M11.25 8h1.5v4h-1.5V8Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M9 2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.25v2.25h-6.5v3.83A3.501 3.501 0 0 0 5.5 22a3.5 3.5 0 0 0 .75-6.92v-2.33h11.5v2.33A3.501 3.501 0 0 0 18.5 22a3.5 3.5 0 0 0 .75-6.92v-3.83h-6.5V9H15a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9Zm.5 1.5v4h5v-4h-5Zm-4 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm15-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgClassification;
